/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface FormateurAzureSearch
 */
export interface FormateurAzureSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurAzureSearch
     */
    centre?: TextSearch;
    /**
     * 
     * @type {number}
     * @memberof FormateurAzureSearch
     */
    idFormateur?: number;
    /**
     * 
     * @type {string}
     * @memberof FormateurAzureSearch
     */
    codeCentres?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormateurAzureSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof FormateurAzureSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurAzureSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurAzureSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FormateurAzureSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof FormateurAzureSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the FormateurAzureSearch interface.
 */
export function instanceOfFormateurAzureSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormateurAzureSearchFromJSON(json: any): FormateurAzureSearch {
    return FormateurAzureSearchFromJSONTyped(json, false);
}

export function FormateurAzureSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormateurAzureSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'centre': !exists(json, 'centre') ? undefined : TextSearchFromJSON(json['centre']),
        'idFormateur': !exists(json, 'idFormateur') ? undefined : json['idFormateur'],
        'codeCentres': !exists(json, 'codeCentres') ? undefined : json['codeCentres'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FormateurAzureSearchToJSON(value?: FormateurAzureSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'centre': TextSearchToJSON(value.centre),
        'idFormateur': value.idFormateur,
        'codeCentres': value.codeCentres,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

